import React, { VFC } from 'react';
import Contact from './Contact';

const ContactContainer: VFC = () => {
  return <Contact />;
};

export default ContactContainer;
